/// <amd-module name="Search/WorkItem/Components/LeftPane/ItemsList" />
import * as React from "react";
import * as SharedResources from "Search/Shared/Resources";
import { List, IListItemDetails, ListItem, IListRow, ListSelection } from "VSSUI/List";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";
import { WorkItemResult } from "Search/LegacyWebApi/Contracts/WorkItem";
import { ItemRow } from "Search/WorkItem/Components/LeftPane/ItemRow";
import { IVssPageContext } from "VSS/Platform/Context";
import { FocusZoneDirection } from "VSSUI/FocusZone";

export interface IItemsListProps {
    items: WorkItemResult[];

    activeItemIndex: number;

    pageContext: IVssPageContext;

    itemsLoading: boolean;

    idWidth: number;

    onWorkItemInvoked(workItemId: number, index: number, url: string, openInNewTab: boolean): void;

    notifyOnRendered(): void;

    onItemActivation(item: WorkItemResult): void;

    renderLoadingRow(): JSX.Element;
}

export class ItemsList extends React.Component<IItemsListProps> {
    private isRendered = false;
    private readonly selection: ListSelection;

    constructor(props: IItemsListProps) {
        super(props);
        this.selection = new ListSelection({ selectOnFocus: false });
        this.selection.select(props.activeItemIndex);
    }

    public render(): JSX.Element {
        const { items, activeItemIndex } = this.props;

        return (
            <List
                className="items-list"
                defaultTabbableRow={activeItemIndex}
                itemProvider={new ArrayItemProvider(items)}
                selection={this.selection}
                width="100%"
                onSelect={this.onSelect}
                onActivate={this.onSelect}
                singleClickActivation={true}
                focuszoneProps={{ direction: FocusZoneDirection.Vertical }}
                selectableText={true}
                renderRow={this.rowRenderer}
                ariaLabel={SharedResources.SearchResultsListAriaLabel} />
        );
    }

    private onSelect = (event: React.SyntheticEvent<HTMLElement>, listRow: IListRow<WorkItemResult>) => {
        this.selection.select(listRow.index);
        this.props.onItemActivation(listRow.data);
    }

    private rowRenderer = (index: number, item: WorkItemResult, details: IListItemDetails<WorkItemResult>): JSX.Element => {
        const { idWidth, renderLoadingRow } = this.props;

        return (
            <ListItem
                index={index}
                details={details}
                className="search-item-list-row">
                {
                    !item.hasOwnProperty("project")
                        ? renderLoadingRow()
                        : <ItemRow
                            item={item}
                            index={index}
                            idWidth={idWidth}
                            pageContext={this.props.pageContext}
                            onRenderComplete={this.onItemRenderComplete}
                            onWorkItemInvoked={this.props.onWorkItemInvoked} />
                }
            </ListItem>
        );
    }

    private onItemRenderComplete = (): void => {
        if (!this.isRendered && !this.props.itemsLoading) {
            this.isRendered = true;
            this.props.notifyOnRendered();
        }
    }
}
